import AboutSection from "./sections/AboutSection";
import TechnologiesSection from "./sections/TechnologiesSection";
import ProjectsSection from "./sections/ProjectsSection";
import ContactSection from "./sections/ContactSection";
import FooterSection from "./sections/FooterSection";
import Navbar from "./components/Navbar";
import { BrowserRouter as Router, Route, Routes, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import ResumeSection from "./sections/ResumeSection";
import BottomNav from "./components/BottomNav";

const App = () => {
  const { i18n } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  
  // Dark mode initialization
  const [darkMode, setDarkMode] = useState(() => {
    const savedMode = localStorage.getItem('darkMode');
    if (savedMode !== null) {
      return savedMode === 'true';
    }
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  });

  // init language based on priority:
  // 1. URL parameter
  // 2. saved preference
  // 3. browser language
  useEffect(() => {
    const urlLang = searchParams.get('lang');
    const savedLang = localStorage.getItem('language');
    const browserLang = navigator.language.toLowerCase();
    
    let preferredLang = 'en'; // default fallback

    if (urlLang && ['en', 'de'].includes(urlLang)) {
      preferredLang = urlLang;
    } else if (savedLang && ['en', 'de'].includes(savedLang)) {
      preferredLang = savedLang;
    } else if (browserLang.startsWith('de')) {
      preferredLang = 'de';
    }

    i18n.changeLanguage(preferredLang);
    setSearchParams({ lang: preferredLang }, { replace: true });
    localStorage.setItem('language', preferredLang);
  }, []);

  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
    localStorage.setItem('darkMode', (!darkMode).toString());
  };

  // listen for system theme changes
  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = (e) => {
      if (localStorage.getItem('darkMode') === null) {
        setDarkMode(e.matches);
      }
    };

    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  // apply dark mode class
  useEffect(() => {
    if (darkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [darkMode]);

  // enhanced language change function
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setSearchParams({ lang: lng }, { replace: true });
    localStorage.setItem('language', lng);
  };

  return (
    <div>
      <Navbar changeLanguage={changeLanguage} toggleDarkMode={toggleDarkMode} darkMode={darkMode}/>
      <AboutSection />
      <TechnologiesSection />
      <ProjectsSection />
      <ResumeSection />
      <ContactSection />
      <FooterSection />
      <BottomNav />
    </div>
  );
};

export default App;
